import { BEHAVIORS } from '@wix/wix-data-client-dbsm-common/src/connection-config/behaviors'

const getComponentBehaviorBinding = bindings =>
  bindings.find(binding => binding.behavior)

const updateComponentBehaviorMetadata = async ({
  editorSdkProxy,
  componentRef,
  behaviorType,
}) => {
  await editorSdkProxy.components.data.update({
    componentRef,
    data: { text: BEHAVIORS[behaviorType].textElement },
  })

  await editorSdkProxy.components.properties.update({
    componentRef,
    props: { isHidden: true },
  })
}

export const syncComponentBehaviorMetadata = async ({
  editorSdkProxy,
  componentRef,
  newBindings,
  oldBindings,
}) => {
  const oldBehaviorBinding = await getComponentBehaviorBinding(oldBindings)
  if (oldBehaviorBinding) {
    clearComponentBehaviorMetadata({
      editorSdkProxy,
      componentRef,
    })
  }

  const newBehaviorBinding = await getComponentBehaviorBinding(newBindings)
  if (newBehaviorBinding) {
    updateComponentBehaviorMetadata({
      editorSdkProxy,
      componentRef,
      behaviorType: newBehaviorBinding.behavior,
    })
  }
}

export const clearComponentBehaviorMetadata = ({
  editorSdkProxy,
  componentRef,
}) =>
  editorSdkProxy.components.properties.update({
    componentRef,
    props: { isHidden: false },
  })
